import React from 'react';
import { makeStyles } from '@mui/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';

import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';

import Link from '@mui/material/Link';
import { Route, Routes, useNavigate } from "react-router-dom";

import { LayoutGrid, Settings as SettingsIcon, LogOut, CircleHelp } from 'lucide-react';

import { AppBar, Avatar, Snackbar, Toolbar, Tooltip } from '@mui/material';
import { useSessionContext } from '../features/login/SessionContext';
import SheetView from '../features/sheet/SheetView';
import SheetGrid from '../features/sheet/SheetGrid';

import SettingsPanel from '../features/settings/SettingsPanel';
import HelpDialog from './HelpDialog';


var gravatar = require('gravatar');


function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'Copyright © '}
            <Link color="inherit" href="https://github.com/mijak99/paper-minis" target="_blank">
                Mikael Jakobsson
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

function Statistics() {
    return (
        <img class="statcounter" src="https://c.statcounter.com/12835131/0/593e06d7/1/" alt="Web Analytics" referrerpolicy="no-referrer-when-downgrade" />
    )
}

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },

    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(0),
        paddingBottom: theme.spacing(2),
    },

    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
}));

export default function Dashboard() {
    const classes = useStyles();
    const session = useSessionContext();

    const [message, setMessage] = React.useState("message");
    const [helpOpen, setHelpOpen] = React.useState(false)
    const [snackOpen, setSnackOpen] = React.useState(false);
    let navigate = useNavigate();

    const [selectedSheet, setSelectedSheet] = React.useState(null);


    function selectSheet(sheet) {
        setSelectedSheet(sheet);
        if (sheet) navigate(`/sheet/${sheet.id}`)
    }

    function alert(message) {
        setMessage(message);
        setSnackOpen(true);
        setTimeout(() => setSnackOpen(false), 5000);
    }

    const avatar = session.isOffline ? <LogOut size={20} strokeWidth={2} /> : (<Avatar alt={session.user.name} src={gravatar.url(session.user.email)} />);

    return (
        <div className={classes.root} >
            <CssBaseline />
            <AppBar >

                <Toolbar>
                    <Box sx={{ flexGrow: 1, display: { xs: 'flex' } }}>

                        <Tooltip title="My sheets">
                            <IconButton
                                size="large"
                                aria-label='My sheets'

                                color='inherit'
                                onClick={e => navigate("/")}
                            >
                                <LayoutGrid size={20} strokeWidth={2} />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Settings">
                            <IconButton
                                size="large"
                                aria-label='Settings'

                                color='inherit'
                                onClick={e => setHelpOpen(true)}
                            >
                                <SettingsIcon size={20} strokeWidth={2} />
                            </IconButton>
                        </Tooltip>
                    </Box>
                    <Box sx={{ flexGrow: 0, display: { xs: 'flex'} }}>

                        <Tooltip title="Show help">
                            <IconButton
                                size="large"
                                aria-label='Show help'


                                color='inherit'
                                onClick={e => setHelpOpen(true)}
                            >
                                <CircleHelp size={20} strokeWidth={2} />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Toolbar>

            </AppBar>
            <main className={classes.content}>
                <Toolbar />
                <Container maxWidth="xl" className={classes.container} height="500">
                    <Grid container spacing={5}>
                        {/* Chart */}
                        <Grid item xs={12} md={12} lg={12}>
                            <Routes>

                                <Route path="*" element={<SheetGrid onSelect={sheet => { selectSheet(sheet); }} />} />
                                <Route path="sheet/:sheetId" element={<SheetView sheet={selectedSheet} alert={alert} onDelete={() => navigate("/")} />} />
                                <Route path="settings" element={<SettingsPanel settings={session.user.settings} />} />
                            </Routes>

                        </Grid>

                    </Grid>
                    <Snackbar autoHideDuration={4000} message={message} open={snackOpen} />
                    <HelpDialog open={helpOpen} onClose={() => setHelpOpen(false)} />
                    <Box pt={4}>
                        <Copyright />
                        <Statistics />
                    </Box>
                </Container>
            </main>
        </div>
    );

}
